export const calMaxPage = (counts) => {
  const maxPage = Math.floor(counts / 10);
  if (counts % 10 === 0) {
    return maxPage;
  } else {
    return maxPage + 1;
  }
};

export const convertDate = (d, divider) => {
  const isYYYYMMDDFormat = /^\d{4}-\d{2}-\d{2}$/.test(d);
  if (!isYYYYMMDDFormat) {
    return d;
  }
  var weekDate = new Date(d);
  const date = weekDate.getDate();
  const month = weekDate.getMonth() + 1;
  const year = weekDate.getFullYear();

  const formattedDate = (date < 10 ? "0" : "") + date;
  const formattedMonth = (month < 10 ? "0" : "") + month;

  return formattedDate + divider + formattedMonth + divider + year;
};

export function formatDateString(inputDate) {
  // Create a Date object from the input string
  const date = new Date(inputDate);

  // Check if the input is a valid date
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  // Format the date components
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();
  // const hours = date.getHours().toString().padStart(2, '0');
  // const minutes = date.getMinutes().toString().padStart(2, '0');
  // const ampm = date.getHours() >= 12 ? 'PM' : 'AM';

  // Construct the formatted date string
  // const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
  const formattedDate = `${day}-${month}-${year}`;

  return formattedDate;
}

export function determineGSTType(gstNumber1, gstNumber2) {
  const ugstTerritories = ["04", "26", "25", "31", "34", "35"];

  const stateCode1 = gstNumber1.substring(0, 2);
  const stateCode2 = gstNumber2.substring(0, 2);

  if (isNaN(stateCode1) || isNaN(stateCode2)) {
    throw new Error("Invalid GST number format");
  }

  if (stateCode1 === stateCode2) {
    if (ugstTerritories.includes(stateCode1)) {
      return ["UGST"];
    } else {
      return ["CGST", "SGST"];
    }
  } else {
    return ["IGST"];
  }
}

export function split_number(number = 0) {
  if (number == 0) {
    return 0;
  }

  if ((number & 1) === 0) {
    let a = number / 2;
    a = a - 1;
    return a;
  } else {
    let b = Math.round(number / 2);
    return b;
  }
}

export function calculateSinglePrice(totalAmount, discountPercentage, quantity) {
  

  // Calculate the original total price
  const originalTotalPrice = totalAmount / (1 - discountPercentage / 100);

  // Calculate the single price
  const singlePrice = originalTotalPrice / quantity;

  return singlePrice;
}